<template>
    <div class="mt-1">
        <b-form-select
            v-model="option"
            :options="filterOptions.accountingFirmUsers"
            :disabled="!viewAllTodos"
            size="sm"
            @change="setFilter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'AccountingFirmUserSelect',

    mixins: [DataUpdater],

    data() {
        return {
            option: 0,
        }
    },

    async mounted() {
        this.option = this.accountingFirmUser
    },

    methods: {
        async setFilter() {
            await this.$store.commit(
                'todoVM/SET_ACCOUNTING_FIRM_USER_OPTION',
                this.option
            )
            this.updateData()
        },
    },

    computed: {
        ...mapState({
            filterOptions: (state) => state.data.options,
            viewAllTodos: (state) => state.todoVM.viewAllTodos,
            accountingFirmUser: (state) => state.todoVM.accountingFirmUser,
        }),
    },
}
</script>

<style scoped></style>
